import { render, staticRenderFns } from "./EditCover.vue?vue&type=template&id=4d084ba6&scoped=true&"
import script from "./EditCover.vue?vue&type=script&lang=js&"
export * from "./EditCover.vue?vue&type=script&lang=js&"
import style0 from "./EditCover.vue?vue&type=style&index=0&id=4d084ba6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d084ba6",
  null
  
)

export default component.exports